<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card news-detail-card">
        <md-card-content class="mobile-content">
          <div class="news-detail-card-wrapper">
            <iframe id="newsFrame" :src='link'></iframe>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import to from "await-to-js";
import axios from "axios";
import config from "@/config";

export default {
  name: "NewsDetailPage",
  data() {
    return {
      error: false,
      html: null
    }
  },
  props: {
    postId: {
      type: [Number, String],
      default: null
    },
    manageOrganizationId: {
      type: [Number, String],
      default: null
    },
    newsType: {
      type: String,
      default: 'Новость'
    }
  },
  mounted() {
    this.$store.commit('SET_CURRENT_NEWS_TYPE_LABEL', this.newsType)
  },
  beforeDestroy() {
    this.$store.commit('SET_CURRENT_NEWS_TYPE_LABEL', null)
  },
  computed: {
    ...mapGetters(["getNewsCompany", "getNewsHome"]),

    link() {
      const host = config.site.host;
      return `${host}/news/htmlcontent/${this.manageOrganizationId}/${this.postId}/`;
    }
  },
};
</script>
<style lang="scss" scoped>
.news-detail-card {
  max-width: 785px;
  @media (max-width: 768px) {
    padding: 0 !important;
    height: calc(100vh - 65px);
    margin-bottom: 0;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      padding: 0 !important;
      height: calc(100vh - 65px);
    }
  }
  &-wrapper {
    padding: 0 10px;
  }
  #newsFrame {
    height: calc(100vh - 165px);
    width: 100%;
    border: none;
    @media (max-width: 768px) {
      height: calc(100vh - 65px);
    }
  }
  iframe:not(.md-image) {
    height: fill-available;
    height: -moz-available;
    height: -webkit-fill-available;
  }
}
</style>
